const initHeader = () => {
  const header = document.querySelector(".g-header");
  const scrollThreshold = vs.isMobileScreen ? 40 : 60;

  const addScrollListener = () => {
    let isDark = false;
    const checkScrollAmount = (e) => {
      if (window.scrollY > scrollThreshold && !isDark) {
        header.classList.add("has-bg");
        isDark = true;
        // window.removeEventListener('scroll', checkScrollAmount);
      } else if (window.scrollY <= scrollThreshold && isDark) {
        header.classList.remove("has-bg");
        isDark = false;
      }
    };
    window.addEventListener("scroll", checkScrollAmount);
    checkScrollAmount();
  };

  const initMobileMenu = () => {
    let mobileMenuActive = false;
    const mobileMenu = document.querySelector("mobile-menu");
    const mobileActiveElements = document.querySelectorAll(
      ".js-mobile-menu-active-only"
    );
    const mobileInactiveElements = document.querySelectorAll(
      ".js-mobile-menu-inactive-only"
    );
    const footer = mobileMenu.querySelector(".js-mobile-menu-footer");
    footer &&
      root.style.setProperty(
        "--s-mobile-menu-footer",
        `${footer.clientHeight}px`
      );

    const initMobileElementStates = () => {
      if (mobileMenuActive) {
        for (let el of mobileActiveElements) {
          el.classList.add("is-active");
        }

        for (let el of mobileInactiveElements) {
          el.classList.remove("is-active");
        }
      } else {
        for (let el of mobileActiveElements) {
          el.classList.remove("is-active");
        }

        for (let el of mobileInactiveElements) {
          el.classList.add("is-active");
        }
      }
    };

    initMobileElementStates();
    on("header", "click", ".js-mobile-menu-open", (e) => {
      scrollDisable();
      mobileMenuActive = true;
      mobileMenu.classList.add("is-active");
      root.classList.add("is-mobile-menu-active");

      initMobileElementStates();
    });

    on("header", "click", ".js-mobile-menu-close", (e) => {
      scrollEnable();
      mobileMenuActive = false;
      mobileMenu.classList.remove("is-active");
      root.classList.remove("is-mobile-menu-active");

      initMobileElementStates();
    });
  };

  if (vs.isMobileScreen) {
    initMobileMenu();
  }

  addScrollListener();

  window.onresize = () => {
    if (vs.isMobileScreen) {
      initMobileMenu();
    }
  };

  // mega menu

  const megaMenus = {};
  const megaMenuContainer = document.querySelector(".js-megamenu-container");

  document.querySelectorAll(".js-megamenu").forEach((menu, index) => {
    megaMenus[menu.dataset.megamenuHandle] = menu;
  });

  // revert all megamenus to the inactive state
  let resetMenus = () => {
    for (const [handle, menu] of Object.entries(megaMenus)) {
      if (menu.classList.contains("is-active")) {
        menu.classList.remove("is-active");
        menu.setAttribute("aria-hidden", "true");
      }
    }
  };

  // activate the specifies megamenu
  let enableMegaMenu = (menu) => {
    resetMenus();
    scrollDisable();
    root.classList.add("is-megamenu-active");
    megaMenuContainer.classList.add("is-active");
    menu.classList.add("is-active");
    megaMenuContainer.style.height = `${menu.clientHeight}px`;
    menu.setAttribute("aria-hidden", "false");
  };

  // close the entire megamenu panel
  const disableMegaMenu = () => {
    scrollEnable();
    resetMenus();
    root.classList.remove("is-megamenu-active");
    megaMenuContainer.classList.remove("is-active");
    megaMenuContainer.style.height = null;
  };

  let isTransitioning = false; // whether we are temporarily blocking menu change while user navigates megamenu
  let potentialTrigger; // trigger for potential menu to switch to
  let switchMenu = true; // whether to switch menus

  // if cursor is moved outside of the trigger in question, don't switch menu
  // only switch menus if the cursor stays on the trigger for over 500 ms
  const detectMouseMove = (e) => {
    if (potentialTrigger) {
      const boundingBox = potentialTrigger.getBoundingClientRect();
      if (
        e.clientX > boundingBox.left &&
        e.clientX < boundingBox.right &&
        e.clientY > boundingBox.top &&
        e.clientY < boundingBox.bottom
      ) {
        switchMenu = true;
      } else {
        switchMenu = false;
      }
    }
  };

  on(".js-megamenu-trigger", "mouseenter", ".js-megamenu-trigger", (e) => {
    // Guard: Do not open megamenu if navigation is disabled
    if (document.querySelector(".g-header").classList.contains("is-nav-disabled")) return;

    const trigger = e.target.closest(".js-megamenu-trigger");
    const megamenuHandle = trigger.dataset.targetMegamenu;
    if (megaMenus[megamenuHandle].classList.contains("is-active")) return;

    // if menu switching is currently being blocked, watch cursor position for next 500ms
    // after 500ms, if cursor is still on the trigger, switch to the respective menu
    if (isTransitioning) {
      potentialTrigger = trigger;
      document.addEventListener("mousemove", detectMouseMove, false);

      setTimeout(() => {
        document.removeEventListener("mousemove", detectMouseMove, false);
        if (switchMenu) {
          enableMegaMenu(megaMenus[megamenuHandle]);
        }
        switchMenu = true;
      }, 500);
    } else {
      enableMegaMenu(megaMenus[megamenuHandle]);
    }
  });

  // maintain flags to block menu switching for 500 ms after moving cursor away from trigger
  on(".js-megamenu-trigger", "mouseleave", ".js-megamenu-trigger", (e) => {
    if (!isTransitioning) {
      isTransitioning = true;
    }

    setTimeout(() => {
      isTransitioning = false;
    }, 500);
  });

  on(".g-header", "mouseleave", ".g-header", (e) => {
    disableMegaMenu();
  });

  const triggers = document.querySelectorAll(".js-megamenu-trigger");

  triggers.forEach((trigger) => {
    const megamenuHandle = trigger.dataset.targetMegamenu;

    // Focus event on the trigger itself
    trigger.addEventListener("focus", (e) => {
      // Guard: Do not open megamenu if navigation is disabled
      if (
        document.querySelector(".g-header").classList.contains("is-nav-disabled")
      )
        return;

      if (
        megaMenus[megamenuHandle] &&
        !megaMenus[megamenuHandle].classList.contains("is-active")
      ) {
        enableMegaMenu(megaMenus[megamenuHandle]);
      }
    });

    // Focus event on any anchor inside the trigger
    const anchors = trigger.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.addEventListener("focus", (e) => {
        // Guard: Do not open megamenu if navigation is disabled
        if (
          document
            .querySelector(".g-header")
            .classList.contains("is-nav-disabled")
        )
          return;

        if (
          megaMenus[megamenuHandle] &&
          !megaMenus[megamenuHandle].classList.contains("is-active")
        ) {
          enableMegaMenu(megaMenus[megamenuHandle]);
        }
      });
    });
  });

  // Fix aria-hidden focus trap
  const originalEnableMegaMenu = enableMegaMenu;
  const originalResetMenus = resetMenus;

  enableMegaMenu = (menu) => {
    // Remove aria-hidden from all menus first to prevent focus traps
    for (const [handle, menuElement] of Object.entries(megaMenus)) {
      menuElement.removeAttribute("aria-hidden");
    }
    originalEnableMegaMenu(menu);
    // Don't set aria-hidden on the active menu
    menu.removeAttribute("aria-hidden");
  };

  resetMenus = () => {
    // Only set aria-hidden on menus that don't contain focused elements
    for (const [handle, menu] of Object.entries(megaMenus)) {
      if (menu.classList.contains("is-active")) {
        menu.classList.remove("is-active");
        // Only set aria-hidden if no focused elements inside
        if (!menu.contains(document.activeElement)) {
          menu.setAttribute("aria-hidden", "true");
        }
      }
    }
  };

  // Keyboard accessibility: Close megamenu when focus leaves the header
  on(".g-header", "focusout", ".g-header", (e) => {
    // Only close if focus is moving completely outside the header
    setTimeout(() => {
      if (
        !document.querySelector(".g-header").contains(document.activeElement)
      ) {
        disableMegaMenu();
      }
    }, 0);
  });

  // close megamenu on internal link page transition
  on("body", "click", "a[href]", (e) => {
    disableMegaMenu();
  });

  // disable navigation on B2B Sales page
  if (header?.classList.contains("is-nav-disabled")) {
    const preventNavClicks = (e) => {
      const target = e.target.closest("a, button, .js-megamenu-trigger");
      if (
        target &&
        (target.closest(".g-header__linklist") ||
          target.closest(".g-header__logo") ||
          target.closest(".g-header__actions") ||
          target.closest(".mobile-menu__linklist") ||
          target.classList.contains("js-mobile-menu-open") ||
          target.classList.contains("js-mobile-menu-close") ||
          target.classList.contains("js-megamenu-trigger"))
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    on("header", "click", "a, button, .js-megamenu-trigger", preventNavClicks);
    on("mobile-menu", "click", "a, button", preventNavClicks);
  }
};

const initPageAnimation = () => {
  document.querySelectorAll("[data-animate]").forEach((item) => {
    let observer = new IntersectionObserver(
      (el) => {
        if (
          el[0].isIntersecting === true &&
          !el[0].target.classList.contains("is-animated")
        ) {
          el[0].target.classList.add("is-animated");
        }
      },
      {
        root: null,
        threshold: [0.05, 1], // 0 = page start; 1 = page bottom, items only revealed when in full view
      }
    );

    observer.observe(item);
  });
};

const initAccordions = () => {
  const toggleAccordion = (accordion, closeSiblings) => {
    const accordionContent = accordion.querySelector(".js-accordion-content");

    if (closeSiblings) {
      getSiblings(accordion).forEach((item) => {
        if (item.classList.contains("is-expanded")) {
          toggleAccordion(item, false);
        }
      });
    }

    accordion.classList.toggle("is-expanded");

    if (accordion.classList.contains("is-expanded")) {
      accordion.setAttribute("aria-expanded", true);
      accordionContent.setAttribute("aria-hidden", false);
      if (accordion.classList.contains("is-metafield")) {
        accordionContent.style.height = `${
          accordionContent.querySelector(".js-accordion-content-wysiwyg")
            .firstElementChild.clientHeight + 18
        }px`;
      } else {
        accordionContent.style.height = `${
          accordionContent.querySelector(".js-accordion-content-wysiwyg")
            .clientHeight
        }px`;
      }
    } else {
      accordion.setAttribute("aria-expanded", false);
      accordionContent.setAttribute("aria-hidden", true);
      accordionContent.style.height = "0px";
    }
  };

  on("button", "click", ".js-accordion-toggle", (e) => {
    const accordion = e.target.closest(".c-accordion");
    toggleAccordion(
      accordion,
      accordion.classList.contains("is-close-siblings")
    );
  });
};

class GlobalRegistration extends HTMLElement {
  constructor() {
    super();
    this.initEventListeners();
  }

  initEventListeners() {
    on("body", "click", ".js-prelaunch-signup", (e) => {
      document.documentElement.classList.add("is-registration-active");
      this.classList.add("is-active");
    });

    on("body", "click", ".js-registration-exit", (e) => {
      document.documentElement.classList.remove("is-registration-active");
      this.classList.remove("is-active");
    });
  }
}

class ComponentSlider extends HTMLElement {
  constructor() {
    super();

    this.options = {};
  }

  connectedCallback() {
    this.init();

    // initialize galleries after slider has mounted
    const galleries = document.querySelectorAll("c-product-gallery");
    if (galleries) {
      for (let gallery of galleries) {
        typeof gallery.init === "function" && gallery.init();
      }
    }
  }

  init() {
    this.enableJump = this.dataset.emblaJump === "true";
    this.viewportNode = this.querySelector(".js-embla-viewport");
    this.containerNode = this.querySelector(".js-embla-container");
    const emblaAutoplay = this.dataset.emblaAutoplay === "true";
    const autoplayDelay = this.hasAttribute("data-embla-delay")
      ? parseInt(this.dataset.emblaDelay)
      : 4000;

    this.enableProgress = this.hasAttribute("data-embla-progress");
    if (this.enableProgress) {
      this.progressNode = this.querySelector(".js-embla-progress");
    }

    this.options = JSON.parse(
      this.dataset.emblaSlider.replace(/'/g, '"').trim()
    );

    const plugins = [EmblaCarouselClassNames()];

    if (emblaAutoplay) {
      this.autoplay = EmblaCarouselAutoplay(
        {
          playOnInit: emblaAutoplay,
          delay: autoplayDelay,
          stopOnInteraction: !emblaAutoplay,
          stopOnMouseEnter: true,
          jump: this.enableJump,
        },
        (emblaRoot) => emblaRoot.parentElement
      );

      plugins.push(this.autoplay);
    }

    if (this.enableJump) {
      plugins.push(EmblaCarouselFade());
    }

    this.embla = EmblaCarousel(this.viewportNode, this.options, plugins);

    this.slideNodes = this.embla.slideNodes();

    if (this.slideNodes.length === 1) {
      this.embla.destroy();
    }

    if (!this.enableJump) {
      if (this.containerNode.scrollWidth <= this.containerNode.offsetWidth) {
        this.embla.reInit({ watchDrag: false });
        this.isActive = false;
      } else {
        this.embla.reInit({ watchDrag: true });
        this.isActive = true;
      }
    }

    this.initializeNavigation();

    this.embla
      .on("init", this.toggleEmblaReady.bind(this))
      .on("resize", this.toggleEmblaReady.bind(this))
      .on("resize", this.resizeHandler.bind(this))
      .on("reInit", this.toggleEmblaReady.bind(this))
      .on("select", this.onSelect.bind(this));
  }

  onSelect(emblaApi) {
    this.onSetClassName();
    emblaApi.off("slidesInView", this.onSelect);

    const previousIndex = this.embla.previousScrollSnap();
    const selectedIndex = this.embla.selectedScrollSnap();
    this.autoplay?.reset();
  }

  resizeHandler() {
    if (
      this.isActive &&
      this.containerNode.scrollWidth <= this.containerNode.offsetWidth
    ) {
      this.embla.reInit({ watchDrag: false });
      this.isActive = false;
    } else if (
      !this.isActive &&
      this.containerNode.scrollWidth > this.containerNode.offsetWidth
    ) {
      this.embla.reInit({ watchDrag: true });
      this.isActive = true;
    }
  }

  toggleEmblaReady(emblaApi, event) {
    if (emblaApi) {
      const isResizeEvent = event === "resize";
      const toggleClass = isResizeEvent ? "remove" : "add";
      this.viewportNode.classList[toggleClass]("embla--is-ready");
      this.onSetClassName();
      !emblaApi.canScrollPrev() && !emblaApi.canScrollNext()
        ? this.classList.add("is-inactive")
        : this.classList.remove("is-inactive");

      if (this.enableProgress) {
        this.setupProgressBar();
      }

      if (isResizeEvent) {
        this.viewportNode.classList.remove("embla--is-fade");
      }

      if (this.enableJump) {
        this.viewportNode.classList.add("embla--is-fade");

        const contentList = this.querySelectorAll(".js-slider-content");

        let maxHeight = 0;
        for (let item of contentList) {
          if (item.scrollHeight > maxHeight) {
            maxHeight = item.scrollHeight;
          }
        }

        const viewport = this.querySelector(".js-embla-viewport");
        if (this.classList.contains("c-press__slider") && vs.isMobileScreen) {
          maxHeight += 64;
        }
        if (viewport) viewport.style.height = `${maxHeight}px`;
      }
    }
  }

  onSetClassName() {
    const removeClass = (selector) => {
      const element = this.viewportNode.querySelector(selector);
      if (element) {
        element.classList.remove(selector.slice(1));
      }
    };
    const addClass = (element, className) => {
      if (element) {
        element.classList.add(className);
      }
    };
    const items = this.viewportNode.querySelectorAll(".product-slider-item");
    const selectedItem = this.viewportNode.querySelector(".is-snapped");
    removeClass(".is-snapped__prev");
    removeClass(".is-snapped__next");
    removeClass(".is-snapped__prev--second");
    removeClass(".is-snapped__next--second");
    const selectedItemIndex = Array.from(items).indexOf(selectedItem);
    const getPreviousItem = ({ index, targetIndexNum }) =>
      items[(index - targetIndexNum + items.length) % items.length];

    const getNextItem = ({ index, targetIndexNum }) =>
      items[(index + targetIndexNum) % items.length];

    addClass(
      getPreviousItem({ index: selectedItemIndex, targetIndexNum: 1 }) ||
        items[items.length - 1],
      "is-snapped__prev"
    );
    addClass(
      getPreviousItem({ index: selectedItemIndex, targetIndexNum: 2 }) ||
        items[items.length - 2],
      "is-snapped__prev--second"
    );
    addClass(
      getNextItem({ index: selectedItemIndex, targetIndexNum: 1 }),
      "is-snapped__next"
    );
    addClass(
      getNextItem({ index: selectedItemIndex, targetIndexNum: 2 }),
      "is-snapped__next--second"
    );

    if (this.classList.contains("js-flavor-slider")) {
      this.initializeClickNavigation();
    }
  }

  initializeNavigation() {
    this.prevButtonNode = this.querySelector(".js-embla-button-prev");
    this.nextButtonNode = this.querySelector(".js-embla-button-next");

    if (this.prevButtonNode && this.nextButtonNode) {
      this.addNavigationHandlers();
      this.toggleNavigationButtonsState();
    }

    this.initializeDotsNavigation();
    this.initializeThumbnailsNavigation();
  }

  addNavigationHandlers() {
    const scrollPrev = () => this.embla.scrollPrev(this.enableJump);
    const scrollNext = () => this.embla.scrollNext(this.enableJump);

    this.prevButtonNode.addEventListener("click", scrollPrev, false);
    this.nextButtonNode.addEventListener("click", scrollNext, false);

    this.removeNavigationHandlers = () => {
      this.prevButtonNode.removeEventListener("click", scrollPrev, false);
      this.nextButtonNode.removeEventListener("click", scrollNext, false);
    };
  }

  toggleNavigationButtonsState() {
    const togglePrevNextBtnsState = () => {
      this.toggleButtonState(this.embla.canScrollPrev(), this.prevButtonNode);
      this.toggleButtonState(this.embla.canScrollNext(), this.nextButtonNode);
    };

    this.embla
      .on("select", togglePrevNextBtnsState)
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState);

    this.removeToggleNavigationButtonsState = () => {
      this.prevButtonNode.removeAttribute("disabled");
      this.nextButtonNode.setAttribute("disabled", "disabled");
    };
  }

  toggleButtonState(condition, button) {
    if (condition) button.removeAttribute("disabled");
    else button.setAttribute("disabled", "disabled");
  }

  initializeDotsNavigation() {
    this.dotsNode = this.querySelector(".js-embla-dots");
    if (this.dotsNode) {
      this.generateDotBtns();
      this.embla.on("select", () => this.selectDotBtn());
      this.embla.on("init", () => this.selectDotBtn());
      // When slides change (e.g. filtering), Embla is re-initialized. Rebuild dots to match new snap list.
      this.embla.on("reInit", () => {
        this.generateDotBtns();
        this.selectDotBtn();
      });
    }
  }

  generateDotBtns() {
    this.dotsNode.innerHTML = "";
    const dotsFrag = document.createDocumentFragment();
    this.dotsArray = this.embla.scrollSnapList().map((_, index) => {
      const button = document.createElement("button");
      button.classList.add("c-slider__dots__dot");
      button.setAttribute("aria-label", `Scroll to slide ${index + 1}`);
      button.addEventListener(
        "click",
        () => this.embla.scrollTo(index, this.enableJump),
        false
      );
      return button;
    });
    this.dotsArray.forEach((dotNode) => dotsFrag.appendChild(dotNode));
    this.dotsNode.appendChild(dotsFrag);
  }

  selectDotBtn() {
    const previous = this.embla.previousScrollSnap();
    const selected = this.embla.selectedScrollSnap();
    if (this.dotsArray?.[previous]) {
      this.dotsArray[previous].classList.remove("is-selected");
    }
    if (this.dotsArray?.[selected]) {
      this.dotsArray[selected].classList.add("is-selected");
    }
  }

  initializeThumbnailsNavigation() {
    this.thumbNode = this.querySelector(".js-embla-thumbs");
    if (this.thumbNode) {
      this.viewportThumbNode = this.thumbNode.querySelector(
        ".js-embla-thumbs-viewport"
      );
      this.emblaThumb = EmblaCarousel(this.viewportThumbNode, {
        axis: "y",
        containScroll: "keepSnaps",
      });
      this.addThumbBtnsClickHandlers();
      this.toggleThumbBtnsActive();
    }
  }

  addThumbBtnsClickHandlers() {
    const slidesThumbs = this.emblaThumb.slideNodes();
    const scrollToIndex = slidesThumbs.map(
      (_, index) => () => this.embla.scrollTo(index)
    );
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.addEventListener("click", scrollToIndex[index], false);
    });

    this.removeThumbBtnsClickHandlers = () => {
      slidesThumbs.forEach((slideNode, index) => {
        slideNode.removeEventListener("click", scrollToIndex[index], false);
      });
    };
  }

  toggleThumbBtnsActive() {
    const slidesThumbs = this.emblaThumb.slideNodes();
    const toggleThumbBtnsState = () => {
      this.emblaThumb.scrollTo(this.embla.selectedScrollSnap());
      const previous = this.embla.previousScrollSnap();
      const selected = this.embla.selectedScrollSnap();
      slidesThumbs[previous].classList.remove("is-selected");
      slidesThumbs[selected].classList.add("is-selected");
      // Expose the selected state to assistive tech (WCAG 4.1.2)
      slidesThumbs[previous]
        .querySelector("button")
        ?.removeAttribute("aria-current");
      slidesThumbs[selected]
        .querySelector("button")
        ?.setAttribute("aria-current", "true");
    };

    this.embla.on("select", toggleThumbBtnsState);
    this.emblaThumb.on("init", toggleThumbBtnsState);

    this.removeToggleThumbBtnsActive = () => {
      const selected = this.embla.selectedScrollSnap();
      slidesThumbs[selected].classList.remove("is-selected");
      slidesThumbs[selected]
        .querySelector("button")
        ?.removeAttribute("aria-current");
    };
  }

  initializeClickNavigation() {
    on("body", "click", ".js-product-slider-item", (e) => {
      this.selectClickedSlide(e);
    });
  }

  selectClickedSlide(e) {
    let slide = e.target.closest(".js-product-slider-item");
    let index = parseInt(slide.getAttribute("data-index"));
    this.embla.scrollTo(index);
  }

  setupProgressBar() {
    const applyProgress = () => {
      const progress = Math.max(0, Math.min(1, this.embla.scrollProgress()));
      this.progressNode.style.transform = `translate3d(${
        progress * 100
      }%,0px,0px)`;
    };

    const removeProgress = () => {
      this.progressNode.removeAttribute("style");
    };

    this.embla
      .on("init", applyProgress)
      .on("reInit", applyProgress)
      .on("scroll", applyProgress)
      .on("destroy", removeProgress);
  }
}

const initVideoPlayer = () => {
  const videoComponents = document.querySelectorAll(".c-video");

  if (!videoComponents.length > 0) return;

  videoComponents.forEach((item) => {
    const vimeo = item.querySelector("[data-vimeo-id]");
    const video = item.querySelector("video");
    const isPreloaded = (video?.preload && video?.preload == "auto") || false;
    const isVimeo = vimeo ? true : false;
    const player = isVimeo ? new Vimeo.Player(vimeo) : video;
    const timeout = isVimeo ? 200 : 0;

    const observer = new IntersectionObserver(
      (el) => {
        if (!isPreloaded) {
          if (el[0].isIntersecting === true) {
            if (player) {
              setTimeout(() => {
                player.play().then(() => {
                  setTimeout(() => {
                    item.classList.add("is-loaded");
                  }, timeout);
                });
              }, 25);
            }
          } else {
            if (player) player.pause();
          }
        } else {
          item.classList.add("is-loaded");
        }
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(item);
  });
};

class ComponentBrewTypes extends HTMLElement {
  constructor() {
    super();

    // sliders
    this.infoSlider = this.querySelector(".js-brew-slider-info");
    this.mediaSlider = this.querySelector(".js-brew-slider-media");

    //  slide arrays
    this.infoSlides = this.infoSlider.embla.slideNodes();
    this.mediaObjects = this.querySelectorAll(".js-brew-media video");

    this.infoContainer = this.querySelector(".js-brew-info-container");
    this.infoSlider.embla.on("select", this.onSelect.bind(this));

    const observer = new IntersectionObserver(
      (el) => {
        if (el[0].isIntersecting === true) {
          this.mediaObjects[0].play();
        } else {
          this.mediaObjects[0].pause();
        }
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(this);
  }

  onSelect() {
    const previousIndex = this.infoSlider.embla.previousScrollSnap();
    const selectedIndex = this.infoSlider.embla.selectedScrollSnap();

    const selectedSlide = this.infoSlides[selectedIndex];
    const selectedColor =
      selectedSlide != null && selectedSlide.getAttribute("data-bg-color");

    if (this.infoContainer && selectedColor) {
      this.infoContainer.style.backgroundColor = selectedColor;
    }

    if (this.mediaObjects) {
      this.mediaSlider.embla.scrollTo(selectedIndex);

      const previousMedia = this.mediaObjects[previousIndex];
      const selectedMedia = this.mediaObjects[selectedIndex];
      if (previousMedia && selectedMedia) {
        previousMedia.pause();
        selectedMedia.play();
      }
    }
  }
}

// class ComponentProductGallery extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.init();
// 	}

// 	connectedCallback() {
// 		this.init();
// 	}

// 	init() {
// 		// sliders
// 		this.gallery = this.querySelector('.js-gallery');
// 		if (this.gallery.embla) {
// 			//  slide arrays
// 			this.gallerySlides = Array.from(this.gallery.embla.slideNodes());
// 			this.thumbsArray = Array.from(this.querySelectorAll('.js-thumb'));
// 			this.activeScrollSnap = this.gallery.embla.selectedScrollSnap();

// 			// edge case where thumbs are hidden (when there is only one product photo)
// 			if (this.thumbsArray.length > 0 && this.activeScrollSnap != null) {
// 				this.thumbsArray[this.activeScrollSnap].classList.add('is-active');
// 			}

// 			this.gallery.embla.on('select', this.onSelect.bind(this));

// 			this.initSlides();

// 			this.initEventListeners();
// 		}
// 	}

// 	// init gallery slides according to first checked input
// 	initSlides() {
// 		const inputs = document.querySelectorAll('.js-variant-selector');
// 		for (let input of inputs) {
// 			if (input.checked) {
// 				const id = input.getAttribute('data-variant-id');
// 				if (id) {
// 					this.updateSliderVariants(parseInt(id));
// 				}
// 			}
// 		}
// 	}

// 	initEventListeners() {
// 		// scroll to corresponding gallery image when thumb is clicked
// 		on('.js-thumbs', 'click', '.js-thumb', (e) => {
// 			const thumb = e.target.closest('.js-thumb');
// 			const newScrollSnap = this.thumbsArray.indexOf(thumb);

// 			this.thumbsArray[this.activeScrollSnap].classList.remove('is-active');
// 			thumb.classList.add('is-active');
// 			this.gallery.embla.scrollTo(newScrollSnap);
// 			this.activeScrollSnap = newScrollSnap;
// 		});

// 		// update gallery content when variant input is clicked
// 		on('body', 'click', '.js-variant-selector', (e) => {
// 			const input = e.target.closest('.js-variant-selector');
// 			if (input) {
// 				const id = input.getAttribute('data-variant-id');
// 				if (id) {
// 					this.updateSliderVariants(parseInt(id));
// 				}
// 			}
// 		});
// 	}

// 	// update gallery content according to selected variant ID
// 	updateSliderVariants(selectedVariantId) {
// 		if (selectedVariantId == null) {
// 			return;
// 		}

// 		let firstVariantSlideIndex;
// 		let firstProductSlideIndex;

// 		for (let i = 0; i < this.gallerySlides.length; i++) {
// 			let gallerySlide = this.gallerySlides[i];
// 			let thumbSlide = this.thumbsArray[i];
// 			let variants = gallerySlide.getAttribute('data-variants');

// 			if (variants) {
// 				variants = variants.split(',').map(Number);

// 				if (variants.includes(selectedVariantId)) {
// 					if (firstVariantSlideIndex == null) {
// 						firstVariantSlideIndex = i;
// 					}
// 					gallerySlide.classList.remove('is-hidden');
// 					thumbSlide.classList.remove('is-hidden');
// 				} else {
// 					// if (firstProductSlideIndex == null) {
// 					// 	firstProductSlideIndex = i;
// 					// }
// 					gallerySlide.classList.add('is-hidden');
// 					thumbSlide.classList.add('is-hidden');
// 				}
// 			} else {
// 				if (firstProductSlideIndex == null) {
// 					firstProductSlideIndex = i;
// 				}
// 			}
// 		}

// 		// if no variant images, scroll to first general product image
// 		if (firstVariantSlideIndex == null) {
// 			this.gallery.embla.scrollTo(firstProductSlideIndex);
// 		} else {
// 			// scroll to first variant product image
// 			this.gallery.embla.scrollTo(firstVariantSlideIndex);
// 		}
// 	}

// 	// update active states when embla scrolls
// 	onSelect() {
// 		const newScrollSnap = this.gallery.embla.selectedScrollSnap();
// 		if (this.activeScrollSnap != null) {
// 			this.thumbsArray[this.activeScrollSnap].classList.remove('is-active');
// 		}
// 		this.thumbsArray[newScrollSnap].classList.add('is-active');
// 		this.activeScrollSnap = newScrollSnap;
// 	}
// }

class SectionTechnicalFeatures extends HTMLElement {
  constructor() {
    super();

    this.initBlockMap();
    this.initTextContainer();
    this.initEventListeners();
    this.activeIndex = 0;

    window.onresize = () => {
      this.initTextContainer();
    };
  }

  initBlockMap() {
    this.media = this.querySelectorAll(".js-media-block");
    this.text = this.querySelectorAll(".js-text-block");
    this.nav = this.querySelectorAll(".js-nav-item");
  }

  initTextContainer() {
    const container = this.querySelector(".js-text-container");

    let max = 0;
    for (let el of this.text) {
      if (el.scrollHeight > max) {
        max = el.scrollHeight;
      }
    }

    container.style.height = `${max}px`;
  }

  initEventListeners() {
    on(".js-technical-features", "click", ".js-nav-item", (e) => {
      const nav = e.target.closest(".js-nav-item");
      const index = parseInt(nav.getAttribute("data-index"));

      this.updateActiveSlides(index);
    });
  }

  updateActiveSlides(newIndex) {
    this.media[this.activeIndex].classList.remove("is-active");
    this.text[this.activeIndex].classList.remove("is-active");
    this.nav[this.activeIndex].classList.remove("is-active");

    this.media[newIndex].classList.add("is-active");
    this.text[newIndex].classList.add("is-active");
    this.nav[newIndex].classList.add("is-active");

    this.activeIndex = newIndex;
  }
}

class SectionSpecs extends HTMLElement {
  constructor() {
    super();

    this.gallery = {};
    this.info = {};
    this.nav = {};

    this.initBlockMap();
    this.initEventListeners();
    this.initTextContainer();
    this.activeSection = null;
    this.updateActiveSlides("machine");
  }

  initBlockMap() {
    const gallerySlides = this.querySelectorAll(".js-gallery-slide");

    for (let slide of gallerySlides) {
      const section = slide.getAttribute("data-section");
      this.gallery[section] = slide;
    }

    const infoSlides = this.querySelectorAll(".js-info-slide");

    for (let slide of infoSlides) {
      const section = slide.getAttribute("data-section");
      this.info[section] = slide;
    }

    const navItems = this.querySelectorAll(".js-nav-item");

    for (let item of navItems) {
      const section = item.getAttribute("data-section");
      this.nav[section] = item;
    }
  }

  initEventListeners() {
    on(".js-specs", "click", ".js-nav-item", (e) => {
      const nav = e.target.closest(".js-nav-item");
      const section = nav.getAttribute("data-section");

      this.updateActiveSlides(section);

      this.style.backgroundColor = nav.getAttribute("data-color");
    });

    window.addEventListener("resize", () => {
      this.initTextContainer();
    });
  }

  initTextContainer() {
    const container = this.querySelector(".js-info");

    let max = 0;

    for (const [key, value] of Object.entries(this.info)) {
      if (value.scrollHeight > max) {
        max = value.scrollHeight;
      }
    }

    container.style.minHeight = `${max}px`;
  }

  updateActiveSlides(section) {
    if (this.activeSection) {
      this.gallery[this.activeSection].classList.remove("is-active");
      this.info[this.activeSection].classList.remove("is-active");
      this.nav[this.activeSection].classList.remove("is-active");
    }

    this.nav[section].classList.add("is-active");
    this.gallery[section].classList.add("is-active");
    this.info[section].classList.add("is-active");

    this.activeSection = section;
  }
}

class ComponentPopupProduct extends HTMLElement {
  constructor() {
    super();

    if (!vs.isMobileScreen) {
      // this.addScrollListener();

      on("body", "click", ".js-popup-exit", (e) => {
        this.hidePopup();
      });

      on("body", "keydown", "body", (e) => {
        if (e.key == "Escape") {
          this.hidePopup();
        }
      });
    }
  }

  hidePopup() {
    this.classList.remove("is-active");
    // setTimeout(() => {
    // 	this.classList.add('is-hidden');
    // }, 1000);
  }

  addScrollListener() {
    const checkScrollAmount = (e) => {
      if (window.scrollY > window.innerHeight) {
        // setTimeout(() => {
        // 	this.classList.remove('is-hidden');
        // }, 2000);
        setTimeout(() => {
          this.classList.add("is-active");
        }, 3000);
        window.removeEventListener("scroll", checkScrollAmount);
      }
    };
    window.addEventListener("scroll", checkScrollAmount);
  }
}

class ArticleContent extends HTMLElement {
  constructor() {
    super();

    this.lightbox = null;
    this._triggerImage = null;
    this._scrollPosition = 0;
    this._isZoomed = false;
    this._onKeydown = (e) => {
      if (e.key === "Escape") {
        if (this._isZoomed) { this._toggleZoom(); }
        else { this.closeLightbox(); }
      }
      if (e.key === "Tab") this._trapFocus(e);
    };
    this.initImages();
  }

  initImages() {
    for (let item of this.children) {
      if (item.getElementsByTagName("img").length > 0) {
        item.classList.add("wysiwyg-image", "f-v", "f-j-c");
        let image = item.getElementsByTagName("img")[0];

        // generate captions from alt text
        if (image.alt) {
          let caption = document.createElement("div");
          caption.classList.add("wysiwyg-image__caption", "t-l-2");
          caption.innerText = image.alt;
          item.appendChild(caption);
        }

        // tag full-bleed (wallpaper) images
        if (image.naturalWidth == 2048) {
          item.classList.add("is-large-image");
        }

        // lightbox click handler
        image.style.cursor = "zoom-in";
        image.setAttribute("tabindex", "0");
        image.setAttribute("role", "button");
        image.setAttribute("aria-label", image.alt ? `View ${image.alt}` : "View image");
        image.addEventListener("click", () => this.openLightbox(image));
        image.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.openLightbox(image);
          }
        });
      }
    }
  }

  openLightbox(image) {
    if (!this.lightbox) this.createLightbox();

    this._triggerImage = image;
    const src = image.dataset.srcset
      ? image.dataset.srcset.split(",").pop().trim().split(" ")[0]
      : image.dataset.src || image.currentSrc || image.src;
    const alt = image.alt || "";

    const lbImg = this.lightbox.querySelector(".c-image-lightbox__img");
    const caption = this.lightbox.querySelector(".c-image-lightbox__caption");

    lbImg.removeAttribute("src");
    this.lightbox.classList.add("is-loading");
    lbImg.onload = () => this.lightbox.classList.remove("is-loading");
    lbImg.onerror = () => this.lightbox.classList.remove("is-loading");
    lbImg.src = src;
    lbImg.alt = alt;

    caption.textContent = alt;
    caption.classList.toggle("is-hidden", !alt);

    // reset zoom state
    this._isZoomed = false;
    this.lightbox.classList.remove("is-zoomed");

    // lock scroll (same pattern as BodyFix helper)
    this._scrollPosition = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${this._scrollPosition}px`;
    document.body.style.width = "100%";

    this.lightbox.classList.add("is-open");
    this.lightbox.querySelector(".c-image-lightbox__close").focus();
    document.addEventListener("keydown", this._onKeydown);
  }

  closeLightbox() {
    if (!this.lightbox) return;
    this.lightbox.classList.remove("is-open");
    document.removeEventListener("keydown", this._onKeydown);

    // restore scroll
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");
    document.body.style.removeProperty("width");
    window.scrollTo(0, this._scrollPosition);

    if (this._triggerImage) {
      this._triggerImage.focus({ preventScroll: true });
      this._triggerImage = null;
    }
  }

  _toggleZoom(e) {
    this._isZoomed = !this._isZoomed;
    this.lightbox.classList.toggle("is-zoomed", this._isZoomed);

    if (this._isZoomed && e) {
      // scroll to click position within the zoomed image
      const container = this.lightbox.querySelector(".c-image-lightbox__container");
      const img = this.lightbox.querySelector(".c-image-lightbox__img");
      const rect = img.getBoundingClientRect();
      const xRatio = (e.clientX - rect.left) / rect.width;
      const yRatio = (e.clientY - rect.top) / rect.height;

      requestAnimationFrame(() => {
        container.scrollLeft = (container.scrollWidth - container.clientWidth) * xRatio;
        container.scrollTop = (container.scrollHeight - container.clientHeight) * yRatio;
      });
    }
  }

  _trapFocus(e) {
    const close = this.lightbox.querySelector(".c-image-lightbox__close");
    e.preventDefault();
    close.focus();
  }

  createLightbox() {
    this.lightbox = document.createElement("div");
    this.lightbox.className = "c-image-lightbox";
    this.lightbox.setAttribute("role", "dialog");
    this.lightbox.setAttribute("aria-modal", "true");
    this.lightbox.setAttribute("aria-label", "Image viewer");
    this.lightbox.innerHTML = `
      <div class="c-image-lightbox__overlay"></div>
      <div class="c-image-lightbox__container">
        <img class="c-image-lightbox__img" src="" alt="">
        <div class="c-image-lightbox__caption t-l-2"></div>
      </div>
      <button class="c-image-lightbox__close" aria-label="Close image viewer">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    `;
    document.body.appendChild(this.lightbox);

    this.lightbox.querySelector(".c-image-lightbox__overlay").addEventListener("click", () => {
      if (this._isZoomed) { this._toggleZoom(); }
      else { this.closeLightbox(); }
    });
    this.lightbox.querySelector(".c-image-lightbox__img").addEventListener("click", (e) => this._toggleZoom(e));
    this.lightbox.querySelector(".c-image-lightbox__close").addEventListener("click", () => this.closeLightbox());
  }
}

class BlogMenu extends HTMLElement {
  constructor() {
    super();
    this.sections = document.querySelectorAll(".js-blog-section");

    // set variable used to calculate scroll padding
    root.style.setProperty(
      "--s-blog-menu",
      `${this.closest(".js-blog-menu").clientHeight}px`
    );

    this.navItems = {};
    this.initNavItems();
    this.initIntersectionObserver();
  }

  initNavItems() {
    for (let section of this.sections) {
      // obtain relevant info
      const titleElement = section.querySelector(".js-blog-section-title");
      if (!titleElement) {
        continue;
      }
      const title = titleElement.innerText;
      const id = section.id;

      // create and append element to menu bar
      const navElement = document.createElement("a");
      const navElementCircle = document.createElement("span");
      const navElementTitle = document.createElement("span");

      navElement.classList.add(
        "blog-menu__nav__item",
        "f-h",
        "f-a-c",
        "js-blog-menu-btn"
      );
      navElement.href = `#${id}`;
      navElement.ariaLabel = `Jump to ${title} section.`;

      navElementCircle.classList.add("blog-menu__nav__item__circle");

      navElementTitle.innerText = title;
      navElementTitle.classList.add("blog-menu__nav__item__title", "t-h-5");

      navElement.appendChild(navElementCircle);
      navElement.appendChild(navElementTitle);

      this.appendChild(navElement);
      this.navItems[id] = navElement;

      if (this.activeNavItem == null) {
        navElement.classList.add("is-active");
        this.activeNavItem = navElement;
      }
    }
  }

  initIntersectionObserver() {
    // change active menu item when scrolling between sections
    const intersectionCallback = (entries) => {
      if (entries[0].isIntersecting) {
        let id = entries[0].target.id;

        if (this.activeNavItem) {
          this.activeNavItem.classList.remove("is-active");
        }

        this.navItems[id].classList.add("is-active");
        this.activeNavItem = this.navItems[id];
      }
    };

    let observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    let observer = new IntersectionObserver(
      intersectionCallback,
      observerOptions
    );

    for (let section of this.sections) {
      observer.observe(section);
    }
  }
}

const initCollectionNav = () => {
  const nav = document.querySelector(".js-collection-nav");
  const header = document.querySelector(".js-collection-header");
  const sections = document.querySelectorAll(".js-collection-category");

  const navItemElements = document.querySelectorAll(".js-nav-item");
  const navItems = {};
  let activeNavItem;
  let isScrolling = false;

  for (let item of navItemElements) {
    const collection = item.getAttribute("data-collection");
    navItems[collection] = item;
  }

  const initIntersectionObserver = () => {
    // change active menu item when scrolling between sections
    const intersectionCallback = (entries) => {
      if (entries[0].isIntersecting) {
        let id = entries[0].target.id;
        if (isScrolling) return;

        if (activeNavItem) {
          activeNavItem.classList.remove("is-active");
        }

        navItems[id].classList.add("is-active");
        activeNavItem = navItems[id];
      }
    };

    let observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    let observer = new IntersectionObserver(
      intersectionCallback,
      observerOptions
    );

    for (let section of sections) {
      observer.observe(section);
    }
  };

  on(".js-collection-nav", "click", ".js-nav-item", (e) => {
    if (activeNavItem) {
      activeNavItem.classList.remove("is-active");
    }

    isScrolling = true;
    setTimeout(() => {
      const navItem = e.target.closest(".js-nav-item");
      navItem.classList.add("is-active");
      if (activeNavItem != navItem) {
        activeNavItem.classList.remove("is-active");
        activeNavItem = navItem;
      }
      isScrolling = false;
    }, 500);
  });

  if (header && nav) {
    header.appendChild(nav);
    root.style.setProperty("--s-collection-nav", `${nav.clientHeight}px`);
    initIntersectionObserver();
  }
};

class SectionFlavorProfiles extends HTMLElement {
  constructor() {
    super();

    on("body", "click", ".js-profiles-close, .js-profiles-open", (e) => {
      e.target.closest(".js-profiles-block").classList.toggle("is-active");
    });
  }
}

class SectionAboutMesh extends HTMLElement {
  constructor() {
    super();

    on("body", "click", ".js-overlay-open, .js-overlay-close", (e) => {
      this.classList.toggle("is-active");
    });
  }
}

class SectionAboutTeam extends HTMLElement {
  constructor() {
    super();

    if (vs.isTouchDevice) {
      on(".js-about-team", "touchstart", ".js-block", (e) => {
        e.target.closest(".js-block").classList.toggle("is-active");
      });
    }
  }
}

const initHelpPage = () => {
  const sectionHeaders = document.querySelectorAll(".js-section-header");
  let navItems = {};

  const navItemElements = document.querySelectorAll(".js-nav-item");
  let activeNavItem;
  let count = 0;
  let isScrolling = false;

  for (let item of navItemElements) {
    const title = item.getAttribute("data-title");
    if (title) {
      navItems[title] = item;
      if (count == 0) {
        item.classList.add("is-active");
        activeNavItem = item;
        count++;
      }
    }
  }

  const calculateScrollPadding = () => {
    let maxHeight = 0;
    for (let header of sectionHeaders) {
      if (header.clientHeight > maxHeight) {
        maxHeight = header.clientHeight;
      }
    }

    root.style.setProperty("--s-header-height", `${maxHeight}px`);
  };

  const initIntersectionObserver = () => {
    // change active menu item when scrolling between sections
    const intersectionCallback = (entries) => {
      if (entries[0].isIntersecting) {
        let id = entries[0].target.id;
        if (isScrolling) return;

        if (activeNavItem) {
          activeNavItem.classList.remove("is-active");
        }

        navItems[id].classList.add("is-active");
        activeNavItem = navItems[id];
      }
    };

    let observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    let observer = new IntersectionObserver(
      intersectionCallback,
      observerOptions
    );

    for (let section of sectionHeaders) {
      observer.observe(section);
    }
  };

  on("body", "click", ".js-nav-item", (e) => {
    if (activeNavItem) {
      activeNavItem.classList.remove("is-active");
    }

    isScrolling = true;
    setTimeout(() => {
      const navItem = e.target.closest(".js-nav-item");
      navItem.classList.add("is-active");
      if (activeNavItem != navItem) {
        activeNavItem.classList.remove("is-active");
        activeNavItem = navItem;
      }
      isScrolling = false;
    }, 500);
  });

  // if url contains anchor link, open the appropriate accordion
  const urlParts = document.URL.split("#");

  if (urlParts.length > 1) {
    const activeFAQ = document.getElementById(urlParts[1]);
    activeFAQ.querySelector(".js-accordion-toggle")?.click();
  }

  calculateScrollPadding();
  initIntersectionObserver();
};

const initCoffeePDP = () => {
  const refreshContent = (target) => {
    const handle = target.dataset.handle;

    // remove old classes
    const prevTarget = document.querySelector(`.js-dynamic-swap.is-active`);
    const prevContent = document.querySelector(`.js-dynamic-content.is-active`);
    if (prevTarget) prevTarget.classList.remove("is-active");
    prevContent.classList.remove("is-active");

    // add new classes
    const targetContent = document.querySelector(
      `.js-dynamic-content[data-handle="${handle}"]`
    );
    targetContent.classList.add("is-active");
    target.classList.add("is-active");

    // swap URL
    const url = "/products/" + handle;
    history.replaceState({}, "", location.origin + url);
  };

  on("body", "click", ".js-dynamic-swap:not(.is-active)", (e) => {
    const target = e.target.closest(".js-dynamic-swap");
    refreshContent(target);
  });

  const currentStoryContent = document.querySelector(".js-coffee-hero");
  currentStoryContent && currentStoryContent.classList.add("is-active");
  const currentRomanceContent = document.querySelector(".js-coffee-romance");
  currentRomanceContent && currentRomanceContent.classList.add("is-active");
};

const initCoffeePLP = () => {
  on(".js-capsule-carousel", "click", ".js-update-product", (e) => {
    const handle = e.target.getAttribute("data-handle");
    getProductData(handle);
    updateURL(handle);
    updateSliderActiveState(e.target);
    setTimeout(() => {
      initServingTooltip();
    }, 1000);
  });

  // fetch product
  const getProductData = (handle) => {
    let product_query = "/collections/all/products/" + handle;
    fetch(product_query)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(response, "text/html");

        const newStoryContent = html.querySelector(".js-coffee-hero");
        const newRomanceContent = html.querySelector(".js-coffee-romance");
        const newGallery = newStoryContent.querySelector(".js-product-gallery");
        newGallery && newGallery.classList.add("is-active");

        currentStoryContent = document.querySelector(".js-coffee-hero");
        currentStoryContent.classList.remove("is-active");

        currentRomanceContent = document.querySelector(".js-coffee-romance");
        currentRomanceContent.classList.remove("is-active");

        setTimeout(() => {
          currentStoryContent.replaceWith(newStoryContent);
          currentRomanceContent.replaceWith(newRomanceContent);
        }, 300);

        setTimeout(() => {
          newStoryContent.classList.add("is-active", "is-animated");
          newRomanceContent.classList.add("is-active", "is-animated");
        }, 800);
      });
  };

  const updateURL = (handle) => {
    const url = "/products/" + handle;
    history.replaceState({}, "", location.origin + url);
  };

  const updateSliderActiveState = (newActiveButton) => {
    if (newActiveButton) {
      const currentActiveSlide = document.querySelector(
        ".js-capsule-carousel .js-capsule-carousel-slide.is-active"
      );
      if (currentActiveSlide) {
        currentActiveSlide.classList.remove("is-active");
      }
      const newActiveSlide = newActiveButton.closest(
        ".js-capsule-carousel-slide"
      );
      newActiveSlide.classList.add("is-active");
    }
  };

  let currentStoryContent = document.querySelector(".js-coffee-hero");
  let currentRomanceContent = document.querySelector(".js-coffee-romance");

  if (currentStoryContent) {
    currentStoryContent.classList.add("is-active");
    currentRomanceContent && currentRomanceContent.classList.add("is-active");

    const activeProduct = currentStoryContent.getAttribute("data-handle");
    const activeSlide = document.querySelector(
      `.js-capsule-carousel-slide[data-handle="${activeProduct}"]`
    );

    activeSlide && updateSliderActiveState(activeSlide);
  }

  const initServingTooltip = () => {
    // add event listeners for serving size tooltip on touch devices
    if (vs.isTouchDevice) {
      const tooltip = document.querySelector(
        ".js-serving-mobile .js-serving-tooltip"
      );

      // hide tooltip when clicked outside
      const detectOutsideClick = (e) => {
        if (!e.composedPath().includes(tooltip)) {
          tooltip.classList.remove("is-active");
          document.removeEventListener("click", detectOutsideClick);
        }
      };

      // display tooltip when icon is clicked
      on("body", "click", ".js-serving-mobile .js-serving-icon", (e) => {
        tooltip && tooltip.classList.add("is-active");
        setTimeout(() => {
          document.addEventListener("click", detectOutsideClick);
        }, 100);
      });
    }
  };
  initServingTooltip();
};

// if there exist >1 <h1> tags, convert all but the first to <p> tags
const initPageHeaders = () => {
  let headers = document.getElementsByTagName("h1");

  if (headers && headers.length > 1) {
    headers = Array.from(headers);
    while (headers.length > 1) {
      const header = headers.pop();
      const newElement = document.createElement("p");
      for (let attr of header.attributes) {
        newElement.setAttributeNS(null, attr.name, attr.value);
      }
      while (header.firstChild) {
        newElement.appendChild(header.firstChild);
      }
      newElement.classList.add("t-h-1");
      header.replaceWith(newElement);
    }
  }
};

const initFrontpageBrews = () => {
  const section = document.querySelector(".js-frontpage-brews");
  const video = document.querySelector(".js-pour-video-desktop");

  // if (section && video) {
  // 	const descriptions = document.querySelectorAll('.js-brews-slide-content');

  // 	const checkVideoProgress = (e) => {
  // 		if (e.seconds > 13) {
  // 			for (let description of descriptions) {
  // 				description.classList.add('is-active');
  // 			}
  // 			video.player.off('timeupdate', checkVideoProgress);
  // 		}
  // 	};

  // 	if (video.player) {
  // 		video.player.on('timeupdate', checkVideoProgress);
  // 	}
  // }

  // init intersection observer
  if (vs.isTabletScreen && section) {
    let isIntersected = false;

    const headline = document.querySelector(".js-brews-headline");
    let observer = new IntersectionObserver(
      (el) => {
        if (el[0].isIntersecting === true && !isIntersected) {
          setTimeout(() => {
            headline.classList.remove("is-active");
          }, 8000);
          isIntersected = true;
        }
      },
      {
        root: null,
        threshold: [0.1, 1], // 0 = page start; 1 = page bottom, items only revealed when in full view
      }
    );

    observer.observe(section);
  }
};

const initProductGalleries = () => {
  let galleries = {};
  let activeGallery;

  Array.from(document.querySelectorAll(".js-product-gallery")).map(
    (gallery, i) => {
      galleries[gallery.getAttribute("data-variant-id")] = gallery;
    }
  );

  if (Object.entries(galleries).length > 0) {
    const urlParams = new URLSearchParams(window.location.search);
    const activeVariant = urlParams.get("variant");

    if (activeVariant && galleries[activeVariant]) {
      activeGallery = galleries[activeVariant];
    } else {
      activeGallery = Object.values(galleries)[0];
    }

    activeGallery.classList.add("is-active");

    // display respective gallery when variant selected
    on("body", "click", ".js-variant-selector", (e) => {
      const input = e.target.closest(".js-variant-selector");
      const form = input.closest(".c-product-form");

      if (form.classList.contains("c-product-form--sticky")) {
        return;
      }

      if (input) {
        const id = input.dataset.variantId;
        activeGallery.classList.remove("is-active");
        galleries[id].classList.add("is-active");
        activeGallery = galleries[id];
      }
    });
  }
};

const initTourPage = () => {
  const tooltip = document.querySelector(".js-share-link-tooltip");
  on("body", "click", ".js-share-link", (e) => {
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          text: "",
          url: window.location.href,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing:", error));
    } else {
      navigator.clipboard.writeText(window.location.href);
      if (tooltip) {
        tooltip.innerHTML = "Copied!";
      }
    }
  });
};

const initQuickUpsells = () => {
  on("body", "submit", ".quick-upsell", (e) => {
    e.preventDefault();

    let formData = new FormData(e.target);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        cCart.updateCartContent();
        cCart.announceCartUpdate("Item added to cart");
        cCart.minicartOpen();
      })
      .catch((error) => {
        console.error("Error adding upsell product to cart:", error);
      });
  });
};

const initOurCoffee = () => {
  const coffeeSection = document.querySelector(".our-coffee");
  if (!coffeeSection) return;

  // Our Coffee now uses the theme's Embla slider component (<c-slider>).
  // The custom element stores its Embla instance at `slider.embla`.
  const coffeeSlider = coffeeSection.querySelector("c-slider");
  const emblaContainer = coffeeSlider?.querySelector(".js-embla-container");
  const allCoffeeTypes = Array.from(
    coffeeSection.querySelectorAll(".our-coffee__coffees-type")
  );

  // Stash for slides removed from the carousel so Embla's snap list/dots updates correctly.
  let slideStash = coffeeSection.querySelector(".js-our-coffee-slide-stash");
  if (!slideStash) {
    slideStash = document.createElement("div");
    slideStash.className = "js-our-coffee-slide-stash";
    slideStash.hidden = true;
    coffeeSection.appendChild(slideStash);
  }

  // Persist original order so filtering doesn't reshuffle slides.
  allCoffeeTypes.forEach((el, idx) => {
    if (!el.dataset.ourCoffeeIndex) el.dataset.ourCoffeeIndex = String(idx);
  });

  const reInitSlider = () => {
    if (!coffeeSlider || !coffeeSlider.embla) return;
    coffeeSlider.embla.reInit();
    coffeeSlider.embla.scrollTo(0);
  };

  const filterCoffee = (forcedValue) => {
    const selectedFilter = coffeeSection.querySelector(
      'input[name="our-coffee-filter"]:checked'
    );
    const filterValue = forcedValue || selectedFilter?.value;
    if (!filterValue) return;
    const coffeeTypes = allCoffeeTypes;

    coffeeTypes.forEach((coffeeType) => {
      const roastTypes = coffeeType
        .getAttribute("data-roasts")
        .split(",")
        .map((r) => r.trim());

      // Handle the special cases for 'Light', 'Medium', and 'Dark' filters
      let shouldDisplay = false;

      if (filterValue === "All") {
        shouldDisplay = true;
      } else if (filterValue === "Light") {
        // Show coffees that have 'Light' or 'Light-Medium' roasts
        shouldDisplay =
          roastTypes.includes("Light") || roastTypes.includes("Light-Medium");
      } else if (filterValue === "Medium") {
        // Show coffees that have 'Medium', 'Light-Medium', or 'Medium-Dark' roasts
        shouldDisplay =
          roastTypes.includes("Medium") ||
          roastTypes.includes("Light-Medium") ||
          roastTypes.includes("Medium-Dark");
      } else if (filterValue === "Dark") {
        // Show coffees that have 'Dark' or 'Medium-Dark' roasts
        shouldDisplay =
          roastTypes.includes("Dark") || roastTypes.includes("Medium-Dark");
      } else {
        // Show only matching roast types for other filters
        shouldDisplay = roastTypes.includes(filterValue);
      }

      // Apply active class based on whether the coffee type should be displayed
      if (shouldDisplay) {
        coffeeType.classList.add("our-coffee__coffees-type--active");

        // Find and activate the matching product for the selected roast
        const matchingProduct = coffeeType.querySelector(
          `.our-coffee-product[data-roast="${filterValue}"]`
        );

        coffeeType
          .querySelectorAll(".our-coffee-product")
          .forEach((product) => {
            product.classList.remove("our-coffee-product--active");
          });

        // If no specific roast matches, activate the first product as a fallback
        if (matchingProduct) {
          matchingProduct.classList.add("our-coffee-product--active");
        } else {
          const firstProduct = coffeeType.querySelector(".our-coffee-product");
          if (firstProduct) {
            firstProduct.classList.add("our-coffee-product--active");
          }
        }
      } else {
        // Hide coffee types that don't match the selected filter
        coffeeType.classList.remove("our-coffee__coffees-type--active");
      }
    });

    // Physically move slides in/out of the Embla container so dots/snaps reflect the filtered set.
    if (emblaContainer) {
      const visible = allCoffeeTypes
        .filter((el) => el.classList.contains("our-coffee__coffees-type--active"))
        .sort(
          (a, b) =>
            parseInt(a.dataset.ourCoffeeIndex || "0") -
            parseInt(b.dataset.ourCoffeeIndex || "0")
        );

      const hidden = allCoffeeTypes
        .filter((el) => !el.classList.contains("our-coffee__coffees-type--active"))
        .sort(
          (a, b) =>
            parseInt(a.dataset.ourCoffeeIndex || "0") -
            parseInt(b.dataset.ourCoffeeIndex || "0")
        );

      visible.forEach((el) => {
        if (el.parentElement !== emblaContainer) emblaContainer.appendChild(el);
      });
      hidden.forEach((el) => {
        if (el.parentElement !== slideStash) slideStash.appendChild(el);
      });
    }

    // After filtering, re-init the slider so snaps/dots/arrows reflect the new slide set.
    requestAnimationFrame(() => {
      // Give layout a beat (display:none -> display:block changes)
      setTimeout(reInitSlider, 25);
    });
  };

  const filterInputs = coffeeSection.querySelectorAll(
    'input[name="our-coffee-filter"]'
  );
  if (filterInputs.length > 0) {
    const filterLabels = coffeeSection.querySelectorAll(
      'label[for^="our-coffee-filter--"]'
    );

    filterInputs.forEach((filter) => {
      filter.addEventListener("change", () => filterCoffee());
    });

    // Robust click handler (event delegation) so the pills keep working even if
    // the inner markup/styling changes.
    coffeeSection.addEventListener(
      "click",
      (e) => {
        const label = e.target.closest('label[for^="our-coffee-filter--"]');
        if (!label) return;

        // Update ARIA states
        filterLabels.forEach((l) => l.setAttribute("aria-pressed", "false"));
        label.setAttribute("aria-pressed", "true");

        // Ensure the corresponding radio is checked
        const forId = label.getAttribute("for");
        const input = forId
          ? coffeeSection.querySelector(`#${CSS.escape(forId)}`)
          : null;
        if (input) input.checked = true;

        // Run filter immediately based on the pill text
        filterCoffee(label.textContent.trim());
      },
      true
    );

    // Add keyboard navigation to filter labels
    filterLabels.forEach((label, index) => {
      label.addEventListener("keydown", (e) => {
        let targetIndex;

        switch (e.key) {
          case "Enter":
          case " ": // Space
            e.preventDefault();
            label.click();
            break;
          case "ArrowRight":
          case "ArrowDown":
            e.preventDefault();
            targetIndex = (index + 1) % filterLabels.length;
            break;
          case "ArrowLeft":
          case "ArrowUp":
            e.preventDefault();
            targetIndex =
              (index - 1 + filterLabels.length) % filterLabels.length;
            break;
          case "Home":
            e.preventDefault();
            targetIndex = 0;
            break;
          case "End":
            e.preventDefault();
            targetIndex = filterLabels.length - 1;
            break;
          default:
            return;
        }

        if (targetIndex !== undefined) {
          filterLabels[targetIndex].focus();
          filterLabels[targetIndex].click();
        }
      });
    });
  }

  const switchProduct = (e) => {
    const clickedBadge = e.target;
    const roastValue = clickedBadge.textContent.trim();
    const parentCoffeeType = clickedBadge.closest(".our-coffee__coffees-type");
    if (!parentCoffeeType) return;

    const allProducts = parentCoffeeType.querySelectorAll(
      ".our-coffee-product"
    );
    allProducts.forEach((product) =>
      product.classList.remove("our-coffee-product--active")
    );

    const selectedProduct = parentCoffeeType.querySelector(
      `.our-coffee-product[data-roast="${roastValue}"]`
    );
    if (selectedProduct) {
      selectedProduct.classList.add("our-coffee-product--active");
    }
  };

  const roastBadges = document.querySelectorAll(
    ".our-coffee-product__roasts-badges button"
  );
  if (roastBadges.length > 0) {
    roastBadges.forEach((badge) => {
      badge.addEventListener("click", switchProduct);
    });
  }
};

const initCoffeesGrid = () => {
  const coffeeSection = document.querySelector(".coffees-grid");
  if (!coffeeSection) return;

  const filterCoffee = () => {
    const selectedFilter = document.querySelector(
      'input[name="coffees-grid-filter"]:checked'
    );
    if (!selectedFilter) return;

    const filterValue = selectedFilter.value;
    const coffeeItems = document.querySelectorAll(".coffee-grid-item");

    coffeeItems.forEach((coffeeItem) => {
      const roastTypes = coffeeItem.getAttribute("data-roasts").split(",");

      // Handle the special cases for 'Light', 'Medium', and 'Dark' filters
      let shouldDisplay = false;

      if (filterValue === "All") {
        shouldDisplay = true;
      } else if (filterValue === "Light") {
        shouldDisplay =
          roastTypes.includes("Light") || roastTypes.includes("Light-Medium");
      } else if (filterValue === "Medium") {
        shouldDisplay =
          roastTypes.includes("Medium") ||
          roastTypes.includes("Light-Medium") ||
          roastTypes.includes("Medium-Dark");
      } else if (filterValue === "Dark") {
        shouldDisplay =
          roastTypes.includes("Dark") || roastTypes.includes("Medium-Dark");
      } else {
        shouldDisplay = roastTypes.includes(filterValue);
      }

      // Apply active class based on whether the coffee item should be displayed
      if (shouldDisplay) {
        coffeeItem.classList.add("coffee-grid-item--active");

        // Activate the matching product for the selected roast
        const matchingProduct = coffeeItem.querySelector(
          `.coffee-grid-item__product[data-roast="${filterValue}"]`
        );

        coffeeItem
          .querySelectorAll(".coffee-grid-item__product")
          .forEach((product) => {
            product.classList.remove("coffee-grid-item__product--active");
          });

        // Activate the first product as a fallback if no specific roast matches
        if (matchingProduct) {
          matchingProduct.classList.add("coffee-grid-item__product--active");
        } else {
          const firstProduct = coffeeItem.querySelector(
            ".coffee-grid-item__product"
          );
          if (firstProduct) {
            firstProduct.classList.add("coffee-grid-item__product--active");
          }
        }
      } else {
        coffeeItem.classList.remove("coffee-grid-item--active");
      }
    });
  };

  const filterInputs = document.querySelectorAll(
    'input[name="coffees-grid-filter"]'
  );
  if (filterInputs.length > 0) {
    const filterLabels = document.querySelectorAll(
      'label[for^="coffees-grid-filter--"]'
    );

    filterInputs.forEach((filter) => {
      filter.addEventListener("change", filterCoffee);
    });

    // Add keyboard navigation to filter labels
    filterLabels.forEach((label, index) => {
      label.addEventListener("click", () => {
        // Update ARIA states
        filterLabels.forEach((l) => l.setAttribute("aria-pressed", "false"));
        label.setAttribute("aria-pressed", "true");
      });

      label.addEventListener("keydown", (e) => {
        let targetIndex;

        switch (e.key) {
          case "Enter":
          case " ": // Space
            e.preventDefault();
            label.click();
            break;
          case "ArrowRight":
          case "ArrowDown":
            e.preventDefault();
            targetIndex = (index + 1) % filterLabels.length;
            break;
          case "ArrowLeft":
          case "ArrowUp":
            e.preventDefault();
            targetIndex =
              (index - 1 + filterLabels.length) % filterLabels.length;
            break;
          case "Home":
            e.preventDefault();
            targetIndex = 0;
            break;
          case "End":
            e.preventDefault();
            targetIndex = filterLabels.length - 1;
            break;
          default:
            return;
        }

        if (targetIndex !== undefined) {
          filterLabels[targetIndex].focus();
          filterLabels[targetIndex].click();
        }
      });
    });
  }

  const switchProduct = (e) => {
    const clickedBadge = e.target;
    const roastValue = clickedBadge.textContent.trim();
    const parentCoffeeItem = clickedBadge.closest(".coffee-grid-item");
    if (!parentCoffeeItem) return;

    const allProducts = parentCoffeeItem.querySelectorAll(
      ".coffee-grid-item__product"
    );
    allProducts.forEach((product) =>
      product.classList.remove("coffee-grid-item__product--active")
    );

    const selectedProduct = parentCoffeeItem.querySelector(
      `.coffee-grid-item__product[data-roast="${roastValue}"]`
    );
    if (selectedProduct) {
      selectedProduct.classList.add("coffee-grid-item__product--active");
    }
  };

  const roastBadges = document.querySelectorAll(
    ".coffee-grid-item__roasts-badges button"
  );
  if (roastBadges.length > 0) {
    roastBadges.forEach((badge) => {
      badge.addEventListener("click", switchProduct);
    });
  }
};

const initSimpleStickyBar = () => {
  const bar = document.querySelector(".simple-sticky-add");

  if (bar) {
    // Don't show simple-sticky-add if product-hero sticky form is present
    const productHeroStickyForm = document.querySelector(
      ".c-product-form--sticky"
    );
    if (productHeroStickyForm) {
      return; // Exit early if product-hero sticky form exists
    }

    const throttle = (func, delay) => {
      let lastCall = 0;
      return (...args) => {
        const now = new Date().getTime();
        if (now - lastCall >= delay) {
          lastCall = now;
          func(...args);
        }
      };
    };

    const handleScroll = () => {
      // Find the regular add to cart form to calculate threshold dynamically
      const regularFormContainer = document.querySelector(
        ".product-hero__info__bottom"
      );
      let threshold = 1200; // Default threshold

      if (regularFormContainer) {
        const containerRect = regularFormContainer.getBoundingClientRect();
        const containerBottom = containerRect.bottom + window.scrollY;
        // Show sticky form only after the regular form has scrolled past the viewport bottom
        // Add 100px buffer to ensure smooth transition
        threshold = containerBottom - window.innerHeight + 100;
      } else {
        // Fallback to fixed threshold if container not found
        threshold = 760;
      }

      if (window.scrollY >= threshold) {
        bar.classList.add("simple-sticky-add--active");
      } else {
        bar.classList.remove("simple-sticky-add--active");
      }
    };

    window.addEventListener("scroll", throttle(handleScroll, 100));
    // Recalculate on resize in case layout changes
    window.addEventListener("resize", throttle(handleScroll, 100));
  }
};

const initCoffeeTypeFilters = () => {
  const radios = document.querySelectorAll("[name='cs-strength']");
  const links = document.querySelectorAll(".coffee-s-coffee");
  const labels = document.querySelectorAll('label[for^="cs-strength--"]');

  const url = new URL(window.location);
  let selectedType = url.searchParams.get("type");

  if (selectedType) {
    radios.forEach((radio) => {
      if (radio.value === selectedType) {
        radio.checked = true;
      }
    });
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", (event) => {
      selectedType = event.target.value;
      url.searchParams.set("type", selectedType);
      window.history.replaceState(null, "", url);

      // Update ARIA states
      labels.forEach((label) => label.setAttribute("aria-pressed", "false"));
      const activeLabel = document.querySelector(
        `label[for="${event.target.id}"]`
      );
      if (activeLabel) {
        activeLabel.setAttribute("aria-pressed", "true");
      }

      links.forEach((link) => {
        const href = link.getAttribute("href");
        if (href) {
          const updatedUrl = new URL(href, window.location.origin);
          updatedUrl.searchParams.set("type", selectedType);
          link.href = updatedUrl.toString();
        }
      });
    });
  });

  // Add keyboard navigation to filter labels
  labels.forEach((label, index) => {
    label.addEventListener("click", () => {
      // Update ARIA states
      labels.forEach((l) => l.setAttribute("aria-pressed", "false"));
      label.setAttribute("aria-pressed", "true");
    });

    label.addEventListener("keydown", (e) => {
      let targetIndex;

      switch (e.key) {
        case "Enter":
        case " ": // Space
          e.preventDefault();
          label.click();
          break;
        case "ArrowRight":
        case "ArrowDown":
          e.preventDefault();
          targetIndex = (index + 1) % labels.length;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          e.preventDefault();
          targetIndex = (index - 1 + labels.length) % labels.length;
          break;
        case "Home":
          e.preventDefault();
          targetIndex = 0;
          break;
        case "End":
          e.preventDefault();
          targetIndex = labels.length - 1;
          break;
        default:
          return;
      }

      if (targetIndex !== undefined) {
        labels[targetIndex].focus();
        labels[targetIndex].click();
      }
    });
  });

  if (selectedType) {
    links.forEach((link) => {
      const href = link.getAttribute("href");
      if (href) {
        const updatedUrl = new URL(href, window.location.origin);
        updatedUrl.searchParams.set("type", selectedType);
        link.href = updatedUrl.toString();
      }
    });
  }
};

const initTextWithVideo = () => {
  document.querySelectorAll(".video-with-text").forEach((container) => {
    const videoContainer = container.querySelector(".video-with-text__video");
    const video = videoContainer.querySelector("video");
    const playButtonOverlay = container.querySelector(
      ".video-with-text__video-play"
    );
    const watchVideoButton = container.querySelector(".play-video-button");
    let ran = false;

    const playOrPauseVideo = () => {
      if (!ran) {
        ran = true;

        // Reveal controls and add the playing class immediately
        video.setAttribute("controls", true);
        videoContainer.classList.add("video-with-text__video--playing");

        // Hide the play button since video controls take over
        playButtonOverlay.style.display = "none";

        // Ensure the video starts playing after a short delay
        setTimeout(() => {
          if (video.paused || video.ended) {
            video.play().catch((err) => {
              console.error("Error playing video:", err);
            });
          }
        }, 50);
      }

      // else {
      // 	video.pause();
      // 	video.removeAttribute('controls');
      // 	videoContainer.classList.remove('video-with-text__video--playing');
      // }
    };

    // The play icon overlay is decorative (aria-hidden + pointer-events:none
    // for a11y), so bind the click to the video container itself — it already
    // has cursor:pointer. Mouse users can click the video/icon to play; the
    // "Watch the video" button remains the keyboard/screen-reader path.
    videoContainer.addEventListener("click", (e) => {
      // Once native controls are showing, let them handle clicks (play/pause,
      // scrubber) instead of re-triggering our handler.
      if (videoContainer.classList.contains("video-with-text__video--playing"))
        return;
      playOrPauseVideo();
    });
    watchVideoButton.addEventListener("click", playOrPauseVideo);
  });
};

const initHomeSaying = () => {
  if (!document.querySelector(".home-saying")) {
    return;
  }

  const OPTIONS = {
    loop: false,
    align: "start",
    slidesToScroll: "auto",
    containScroll: "trimSnaps",
  };

  const emblaNode = document.querySelector(".embla");
  const viewportNode = emblaNode.querySelector(".embla__viewport");
  const prevBtnNode = emblaNode.querySelector(".embla__button--prev");
  const nextBtnNode = emblaNode.querySelector(".embla__button--next");
  const dotsNode = emblaNode.querySelector(".embla__dots");

  if (!emblaNode || !viewportNode || !dotsNode) return;

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

  // Create dots based on the number of scroll snaps (pages)
  const createDots = () => {
    const snapPoints = emblaApi.scrollSnapList();
    dotsNode.innerHTML = ""; // Clear existing dots

    snapPoints.forEach((_, index) => {
      const button = document.createElement("button");
      button.className = "embla__dot";
      button.type = "button";
      button.setAttribute("aria-label", `Go to page ${index + 1}`);
      button.addEventListener("click", () => emblaApi.scrollTo(index), false);
      dotsNode.appendChild(button);
    });
  };

  // Update dots' active state
  const updateDots = () => {
    const selectedIndex = emblaApi.selectedScrollSnap();
    const dots = Array.from(dotsNode.querySelectorAll(".embla__dot"));
    dots.forEach((dot, index) => {
      const isActive = index === selectedIndex;
      dot.classList.toggle("is-active", isActive);
      // Expose the selected dot to screen readers (WCAG 4.1.2).
      if (isActive) {
        dot.setAttribute("aria-current", "true");
      } else {
        dot.removeAttribute("aria-current");
      }
    });
  };

  // Attach event listeners to navigation buttons
  prevBtnNode.addEventListener("click", () => emblaApi.scrollPrev(), false);
  nextBtnNode.addEventListener("click", () => emblaApi.scrollNext(), false);

  // Initialize dots and attach Embla event listeners
  emblaApi.on("init", () => {
    createDots();
    updateDots();
  });
  emblaApi.on("select", updateDots);
  emblaApi.on("reInit", () => {
    createDots();
    updateDots();
  });

  document
    .querySelectorAll(".home-saying-block__media")
    .forEach((mediaBlock) => {
      const video = mediaBlock.querySelector("video");
      const muteButton = mediaBlock.querySelector(
        ".home-saying-block__media-unmute"
      );

      if (video && muteButton) {
        muteButton.addEventListener("click", () => {
          video.muted = !video.muted; // Toggle mute
          muteButton.classList.toggle(
            "home-saying-block__media-unmute--muted",
            video.muted
          );

          // Update aria-label for accessibility
          const mutedLabel =
            muteButton.getAttribute("data-muted-label") || "Unmute video";
          const unmutedLabel =
            muteButton.getAttribute("data-unmuted-label") || "Mute video";
          muteButton.setAttribute(
            "aria-label",
            video.muted ? mutedLabel : unmutedLabel
          );
        });
      }
    });
};

initTextWithVideo();
initCoffeeTypeFilters();
initSimpleStickyBar();
initPageHeaders();
initPageAnimation();
initCoffeePDP();
initAccordions();
initVideoPlayer();
initQuickUpsells();
initOurCoffee();
initCoffeesGrid();
initHomeSaying();

customElements.define("c-slider", ComponentSlider);
customElements.define("c-brew-types", ComponentBrewTypes);
customElements.define("c-popup-product", ComponentPopupProduct);
// customElements.define('c-product-gallery', ComponentProductGallery);

customElements.define("article-content", ArticleContent);
customElements.define("blog-menu", BlogMenu);
customElements.define("flavor-profiles", SectionFlavorProfiles);
customElements.define("about-mesh", SectionAboutMesh);
customElements.define("about-team", SectionAboutTeam);

customElements.define("s-technical-features", SectionTechnicalFeatures);
customElements.define("s-specs", SectionSpecs);
customElements.define("g-registration", GlobalRegistration);

initHeader();
initFrontpageBrews();

const initEkoHybridGalleries = () => {
  const hybrids = document.querySelectorAll(".product-hero__gallery__hybrid");
  if (!hybrids.length) return;

  // Note: the older `window.eko.gallery.setActive("1"|"0")` call was removed
  // intentionally. Eko's API interprets that string as a chapter *index*,
  // not a boolean active-flag — calling it with "1" would jump the player
  // to chapter 1 (Cold Brew) every time the user activated the Eko thumb.
  // With this removed Eko simply stays at its default first chapter.

  hybrids.forEach((hybrid) => {
    const column =
      hybrid.closest(".product-hero__gallery__column") ||
      hybrid.parentElement ||
      document;
    const slider = hybrid.querySelector("c-slider.js-hybrid-gallery");
    const strip = column.querySelector(".js-extra-strip");

    // Strip `galleryBlockMode=gallery` from the Eko iframe src. Without
    // this query param Eko renders its own in-iframe navigation; with it,
    // the iframe is just the video area and expects the host page to
    // provide navigation. We're testing the former so we hide our custom
    // chip bar (via CSS) and let Eko drive navigation inside the iframe.
    //
    // Simply updating the `src` attribute on the existing iframe does NOT
    // reliably trigger a navigation (Eko's own script appears to hold the
    // iframe's committed load at its original URL). Replacing the iframe
    // element with a clone forces a brand-new navigation to the stripped
    // URL while preserving all original attributes.
    const stripFromUrl = (src) =>
      src
        .replace(/[?&]galleryBlockMode=[^&#]*/, (m) =>
          m.charAt(0) === "?" ? "?" : ""
        )
        .replace(/\?&/, "?")
        .replace(/\?$/, "");

    const replaceEkoIframe = (iframe) => {
      if (!iframe) return;
      const src = iframe.getAttribute("src") || "";
      if (!src.includes("galleryBlockMode=")) return;
      const next = stripFromUrl(src);
      if (next === src) return;
      const fresh = iframe.cloneNode(false);
      fresh.setAttribute("src", next);
      iframe.parentNode.replaceChild(fresh, iframe);
    };

    const patchEkoIframe = () => {
      const iframe = hybrid.querySelector(
        ".eko-smart-gallery-container iframe"
      );
      if (!iframe) return false;
      replaceEkoIframe(iframe);
      // Watch the gallery container for Eko re-inserting a fresh iframe
      // (e.g., on variant change) and re-strip its URL.
      const container = hybrid.querySelector(".eko-smart-gallery-container");
      if (container) {
        const obs = new MutationObserver(() => {
          const next = container.querySelector("iframe");
          if (next && next.getAttribute("src")?.includes("galleryBlockMode=")) {
            replaceEkoIframe(next);
          }
        });
        obs.observe(container, { childList: true, subtree: true });
      }
      return true;
    };
    if (!patchEkoIframe()) {
      const iframeObs = new MutationObserver(() => {
        if (patchEkoIframe()) iframeObs.disconnect();
      });
      iframeObs.observe(hybrid, { childList: true, subtree: true });
    }

    if (!slider || !strip) return;

    const thumbs = Array.from(
      strip.querySelectorAll(".js-extra-strip__item")
    );

    // Tracks the index the user most recently intended to select. This is
    // the authoritative source of truth for thumb highlighting and Eko
    // active state. Embla's own `select` event can fire asynchronously
    // with a stale selectedScrollSnap() during the scroll animation, so
    // we only let Embla drive state when the user wasn't the most recent
    // trigger (e.g. arrow / swipe navigation).
    let activeIndex = 0;
    let lastClickAt = 0;
    const CLICK_LOCK_MS = 600;

    const applyState = (index) => {
      activeIndex = index;
      const isEkoActive = index === 0;
      hybrid.classList.toggle("is-eko-active", isEkoActive);
      thumbs.forEach((t, i) => {
        const active = i === index;
        t.classList.toggle("is-active", active);
        t.setAttribute("aria-pressed", active ? "true" : "false");
      });
    };

    const syncFromEmbla = () => {
      if (!slider.embla) return;
      // Ignore Embla's select event if we just responded to a click;
      // during the scroll animation selectedScrollSnap() can return a
      // transient intermediate value that would un-highlight the thumb
      // the user just clicked.
      if (Date.now() - lastClickAt < CLICK_LOCK_MS) return;
      applyState(slider.embla.selectedScrollSnap());
    };

    const attach = (attempts = 0) => {
      if (slider.embla) {
        slider.embla.on("select", syncFromEmbla);
        // Initial sync: always run regardless of click lock.
        applyState(slider.embla.selectedScrollSnap());
        return;
      }
      if (attempts > 50) return;
      setTimeout(() => attach(attempts + 1), 100);
    };
    attach();
    // Re-init Embla on mobile after the CSS unhides the
    // slider, so it picks up correct measurements.
    if (window.matchMedia("(max-width: 1024px)").matches) {
      const reInit = () => slider.embla?.reInit();
      requestAnimationFrame(() => requestAnimationFrame(reInit));
      window.addEventListener("resize", reInit, { passive: true });
    }

    strip.addEventListener("click", (e) => {
      const btn = e.target.closest(".js-extra-strip__item");
      if (!btn) return;
      const idx = Number(btn.dataset.slideIndex || 0);
      lastClickAt = Date.now();
      // Apply visual state immediately so the click feels instant and
      // isn't dependent on Embla's scroll animation completing.
      applyState(idx);
      if (slider.embla) {
        slider.embla.scrollTo(idx);
      }
    });
  });
};

// execute page specific functions
switch (root.classList[0]) {
  case "template-collection":
    initCoffeePLP();
    initCollectionNav();
    break;
  case "template-list-collections":
    initProductGalleries();
    initCollectionNav();
    break;
  case "template-product":
    initProductGalleries();
    initEkoHybridGalleries();
    initCoffeePLP();
    break;
  case "template-page-help":
    initHelpPage();
    break;
  case "template-page-cold-coffee-tour":
    initTourPage();
    break;
}
